import { NextSeo } from 'next-seo';
import LLCIncorporationPage from '_components/composed/pages/LLCIncorporationPage';

export default function LLCIncorporation() {
  return (
    <>
      <NextSeo
        title="Form Your LLC with Incorpified - Quick and Accurate Setup"
        description="Form your LLC with Incorpified. Our expert service ensures a quick and accurate setup, providing you with the protection and benefits of a Limited Liability Company."
      />
      <LLCIncorporationPage />
    </>
  );
}
